import { createSlice } from '@reduxjs/toolkit';

const savedAuthState = localStorage.getItem('authState');
const initialState = savedAuthState ? JSON.parse(savedAuthState) : {
  isAuthenticated: false,
  clientId: null,
  communityId: null,
  emailId: null,
  employeeId: null,
  roleId: null,
  roleIdNav: null,
  token: null,
  userId: null,
  managerId: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.userId = action.payload.userId;
      state.roleId = action.payload.roleId;
      state.roleIdNav = action.payload.roleId;
      state.token = action.payload.token;
      state.clientId = action.payload.clientId;
      state.communityId = action.payload.communityId;
      state.employeeId = action.payload.employeeId;
      state.emailId = action.payload.emailId;
      state.managerId = action.payload.managerId;

      localStorage.setItem('authState', JSON.stringify(state));
      sessionStorage.setItem('authState', JSON.stringify(state));
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.clientId = null;
      state.communityId = null;
      state.emailId = null;
      state.employeeId = null;
      state.roleId = null;
      state.roleIdNav = null;
      state.token = null;
      state.userId = null;
      state.managerId = null;

      localStorage.removeItem('authState');
      sessionStorage.removeItem('authState');
    },
    setCommunityId: (state, action) => {
      state.communityId = action.payload;
      localStorage.setItem('authState', JSON.stringify(state));
      sessionStorage.setItem('authState', JSON.stringify(state));
    },
    removeCommunityId: (state) => {
      state.communityId = null;
      localStorage.setItem('authState', JSON.stringify(state));
      sessionStorage.setItem('authState', JSON.stringify(state));
    },

    toggleRole: (state) => {
      if (state.roleId === 1003) {
        state.roleId = state.roleIdNav; 

      } else {
        state.roleId = 1003;
      }
      localStorage.setItem('authState', JSON.stringify(state));
      sessionStorage.setItem('authState', JSON.stringify(state));
    },
  },
});

export const { login, logout, setCommunityId, removeCommunityId, toggleRole } = authSlice.actions;
export const selectAuth = (state) => state.auth;
export default authSlice.reducer;
